export default function Profile() {
  return (
    <section className="py-20 sm:py-24 lg:py-28 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 sm:mb-20">
          <div className="inline-block mb-5 sm:mb-7">
            <span className="border-2 border-[#1e3a8a] text-[#1e3a8a] text-xs font-semibold px-4 sm:px-6 py-2 rounded-full uppercase tracking-wider whitespace-nowrap">
              Profile
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a8a] mb-5 sm:mb-7 leading-tight px-4">
            タレント 菊田あや子
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 items-center">
          {/* プロフィール画像 */}
          <div className="order-1 lg:order-1">
            <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/5b3c9bf2cc89003aa9f6224022a3d624/029c3564ea0014ba3f0a6f556810d113.jpeg"
                alt="タレント 菊田あや子"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* プロフィール詳細 - PC版のみmax-widthを制限 */}
          <div className="order-2 lg:order-2">
            <div className="space-y-5 sm:space-y-6 text-sm sm:text-base lg:text-[20px] text-gray-700 leading-relaxed lg:leading-[1.8] lg:max-w-[650px] lg:mx-auto">
              <p>
                30年以上にわたるメディアキャリアを持ち、テレビ・ラジオ・雑誌など多岐にわたる活動を通じて、幅広い層から信頼を獲得。
              </p>
              <p>
                特に50代以上の女性層に対して、共感と安心感を与える存在として高い支持を得ています。
              </p>
              <p>
                現在は50代以上の女性コミュニティや韓国語スクールを主宰。この現場で培った<strong className="text-[#1e3a8a]">「彼女たちが今、本当に求めている体験」</strong>への深い理解が、他社には真似できない独自の企画力と訴求力の源泉となっています。
              </p>
              <p>
                その専門性と実績を活かし、旅行会社向けの集客・広報支援サービスを展開。ツアーの魅力を的確に伝え、参加者の満足度を高めることで、リピーターの獲得と口コミによる拡散を実現しています。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}